// Components

// Core components
// import '../common/components/sample/sample';
// import '../../common/components/image-zoom/image-zoom'; // Need to be in top to add zoom in jQuery
import '../../common/components/carousel/carousel';
import '../../common/components/homepage-hero/homepage-hero';
import '../../common/components/footer/footer';
import '../../common/components/accordion/accordion';
import '../../common/components/accordion/accordions';
import '../../common/components/header/header';
import '../../common/components/card-carousel/card-carousel';
import '../../common/components/slide-toggle/slide-toggle';
import '../../common/components/contact/contact';
import '../../common/components/social-media-share/social-media-share';
import '../../common/components/blockquote/blockquote';
import '../../common/components/contact/kentico-form';
import '../../common/components/cookie-banner/cookie-banner';
import '../../common/components/case-study/case-study';
import '../../common/components/space-recipe/space-recipe';
import '../../common/components/culture-pop-up/culture-pop-up';
import '../../common/components/geo-location/geo-location';
import '../../common/components/sebel-pop-up/sebel-pop-up';
import '../../common/components/pop-up-form/pop-up-form';
import '../../common/js/product-listing';

import { updateScrollAnimation } from '../../common/components/site-wide-banner/site-wide-banner';

//Custom components
// import './components/sample/sample';

window.addEventListener('load', updateScrollAnimation);
window.addEventListener('resize', updateScrollAnimation);
